import React from 'react';
import { PropTypes } from 'prop-types';
import ProgressBar from 'components/orders/ProgressBar';

const Addresses = ({ className, t, addressFrom, addressTo }) => (
  <div className={className}>
    <ul>
      <li>
        <ProgressBar />
        <div className="step-data-wrapper">
          <div className="companyName">
            {t('addresses.pickup', {
              pickupCompany: addressFrom.company_name,
              pickupCity: addressFrom.city,
            })}
          </div>
          <div className="addressLine">{addressFrom.address_line}</div>
        </div>
      </li>
      <li>
        <ProgressBar />
        <div className="step-data-wrapper">
          <div className="companyName">
            {t('addresses.dropoff', {
              dropoffCompany: addressTo.company_name,
              dropoffCity: addressTo.city,
            })}
          </div>
          <div className="addressLine">{addressTo.address_line}</div>
        </div>
      </li>
    </ul>
    <hr />
  </div>
);

Addresses.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  addressFrom: PropTypes.any,
  addressTo: PropTypes.any,
};

Addresses.defaultProps = {
  className: '',
  t: (t) => t,
  addressFrom: {},
  addressTo: {},
};

export default Addresses;
